var style = {
  "Container": "_Container_ijalm_1"
};

export { style as default };
